module.exports = __webpack_public_path__ + "img/ahs.e01a3e4d.jpg";